import { defineComponent as _defineComponent } from 'vue'
import CommonButton from '@/components/CommonButton.vue';
import CommonToast from '@/components/CommonToast.vue';
import QRCode from '@/components/QRCode.vue';
import { Icons } from '@/font-awesome';
import { CommonToastInjection } from '@/infra/constants/injections';
import { useReqRenewBenefitsCardPlansStore } from '@/stores/benefits_card_plans/request_renew_benefits_cards_plan_store';
import { DOMUtils } from '@/utils/dom_utils';
import FormatUtils from '@/utils/format_utils';
import { inject, Ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentScreen',
  props: {
    showScreen: { type: Boolean, required: true }
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const reqRenewBenCardsPlanStore = useReqRenewBenefitsCardPlansStore;
const commonToast = inject<Ref<InstanceType<typeof CommonToast>>>(CommonToastInjection);






const __returned__ = { reqRenewBenCardsPlanStore, commonToast, CommonButton, QRCode, get Icons() { return Icons }, get DOMUtils() { return DOMUtils }, get FormatUtils() { return FormatUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})